






import {Vue, Component, Prop} from "vue-property-decorator";

@Component( {
    components: {}
})
export default class ControlWrapper extends Vue {

    @Prop({ default: 'grey'}) modificationName: string;

}
